import React from 'react';
import PropTypes from 'prop-types';
import { PropTypes as MobxPropTypes } from 'mobx-react';

import { Select } from '../../../common/select';

const IPropTypes = {
  className: PropTypes.string,
  onFilterChange: PropTypes.func.isRequired,
  selectedFilter: PropTypes.number.isRequired,
  filterOptions: MobxPropTypes.arrayOrObservableArray.isRequired,
};

const defaultProps = {
  className: '',
};

const IntraSearchFilter = (props) => {
  const getFilterLabel = value => (
    props.filterOptions.find(filter => filter.value === value).label
  );

  return (
    <Select
      options={props.filterOptions.slice()}
      className={props.className}
      onChange={props.onFilterChange}
      value={getFilterLabel(props.selectedFilter)}
    />
  );
};

IntraSearchFilter.propTypes = IPropTypes;
IntraSearchFilter.defaultProps = defaultProps;

export { IntraSearchFilter };



// WEBPACK FOOTER //
// ./src/pages/product-index/intra-search-filter/IntraSearchFilter.jsx